import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemSlotsProvider, LineItemCard, LineItemModels, GlassesPrescription, PrescriptionTable } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { QuantitySelector } from '../components/QuantitySelector.js';
import { DeliveryIndicatorContainer } from '../containers/DeliveryIndicatorContainer.js';

const VisualLineItemsContainer = ({ lineItems , readOnly  })=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem)=>{
        const baseProps = {
            labels,
            currency: intl.currency,
            discountPrice: lineItem.discountPrice ? lineItem.price : 0,
            relativeDiscount: lineItem.relativeDiscount,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: lineItem.originalPrice || lineItem.price,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            compactCard: false,
            hideDiscountSection: false
        };
        if ('bundleChildLineItems' in lineItem) {
            baseProps.bundleChildLineItems = lineItem.bundleChildLineItems;
        }
        const LineItemCardSlot = {
            QuantitySelector: ()=>/*#__PURE__*/ React.createElement(QuantitySelector, {
                    hideQuantity: lineItem.type === 'CONTACT_LENS_BUNDLE',
                    lineItemId: lineItem.lineItemId,
                    readOnly: readOnly
                })
            ,
            StockAndDelivery: ()=>/*#__PURE__*/ React.createElement(DeliveryIndicatorContainer, {
                    lineItemId: lineItem.lineItemId
                })
        };
        return /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            key: lineItem.sku,
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: lineItem.sku,
            imageHref: lineItem.productUrl
        }, baseProps), 'prescription' in lineItem ? /*#__PURE__*/ React.createElement(LineItemCard.PrescriptionSection, {
            labels: labels
        }, LineItemModels.isGlassesBundleLineItem(lineItem) ? /*#__PURE__*/ React.createElement(GlassesPrescription, {
            intl: intl,
            prescription: lineItem.prescription
        }) : /*#__PURE__*/ React.createElement(PrescriptionTable, {
            size: "narrow",
            orientation: "eyeSideTop",
            formatPrescription: true,
            prescription: swcHelpers.objectSpread({}, lineItem.prescription)
        })) : null));
    }));
};

export { VisualLineItemsContainer };
//# sourceMappingURL=VisualLineItemsContainer.js.map
